
import { defineComponent } from 'vue';
import AdListItem from '@/ad/mixins/AdListItem';
//import MapStatic from '@/shared/components/MapStatic.vue';
import MapPositionReadonly from '@/shared/components/MapPositionReadonly.vue';
import { isElementVisible } from '@/shared/helpers/isElementVisible';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';

export default defineComponent({
  mixins: [AdListItem],
  name: 'AdListItemMobile',
  components: {
    //MapStatic,
    MapPositionReadonly,
  },
  data() {
    return {
      isMapVisible: false,
      mapType: null,
      mapState: 1,
    };
  },
  methods: {
    toggleMap() {
      if (this.mapState === 3) this.mapState = 1;
      else this.mapState++;

      this.isMapVisible = this.mapState !== 1;
      this.mapType = this.mapState === 2 ? 'roadmap' : 'hybrid';

      if (this.$refs.map) {
        this.$refs.map.setMapType(this.mapType);
      }

      if (this.isMapVisible) {
        this.scrollToAd(this.ad);
      }
      googleTagManagerService.send({
        event: 'mapa_galeria_mobile_click',
      });
    },
    scrollToAd(ad: any) {
      const el = this.$el.parentNode.getElementsByClassName('estate-listing-' + ad.adId)[0];
      if (el) {
        if (!isElementVisible(el)) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },
  },
});
